import {Notice} from "../../models/notice";
import React from "react";
import {Grid, ListItem, ListItemButton} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {getShortenDateTimeWithYear} from "../../utils/Utils";

interface NoticeListItemSpec {
    notice: Notice
}

export const NoticeListItem: React.FC<NoticeListItemSpec> = ({notice}) => {
    const navigate = useNavigate()
    const noticeCreatedDate = new Date(notice.createdAt)

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate(`/notice/${notice.id}`)}}>
                <Grid direction={'column'} container>
                    <Grid item>
                        <span style={{fontWeight: 700}}>
                            {notice.title}
                        </span>
                    </Grid>
                    <Grid item>
                        <span className={"description-text"}>{getShortenDateTimeWithYear(noticeCreatedDate)}</span>
                    </Grid>
                </Grid>
            </ListItemButton>
        </ListItem>
    )
}